import * as React from 'react';

const SvgOutlineLocation = (props) => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M12 6.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5ZM9.75 10a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z'
    />
    <path
      clipRule='evenodd'
      d='M12 .25c-4.883 0-8.75 4.243-8.75 9.359 0 1.64.815 3.572 1.84 5.386 1.043 1.842 2.373 3.681 3.539 5.168l.039.05c.57.726 1.054 1.344 1.524 1.771.513.466 1.079.771 1.808.771.73 0 1.295-.305 1.808-.77.47-.428.955-1.046 1.524-1.772l.039-.05c1.166-1.487 2.496-3.326 3.538-5.168 1.026-1.814 1.841-3.746 1.841-5.386C20.75 4.493 16.883.25 12 .25ZM4.75 9.609C4.75 5.216 8.047 1.75 12 1.75s7.25 3.466 7.25 7.859c0 1.226-.64 2.867-1.646 4.647-.99 1.75-2.27 3.523-3.413 4.982-.62.789-1.027 1.305-1.392 1.636-.333.302-.555.382-.799.382s-.466-.08-.8-.382c-.364-.331-.772-.847-1.39-1.636-1.144-1.459-2.424-3.232-3.414-4.982-1.006-1.78-1.646-3.42-1.646-4.647Z'
    />
  </svg>
);

export default SvgOutlineLocation;
